import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39c05dc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderConfirm_operationWrapper" }
const _hoisted_2 = { class: "Flex_Wrapper" }
const _hoisted_3 = { class: "OrderConfirm_BtnBlock" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_7 = { class: "paging_container" }
const _hoisted_8 = {
  key: 0,
  class: "OrderConfirm_Table"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_Sticky_TH" }, "受注ID"),
    /*#__PURE__*/_createElementVNode("th", null, "明細ID"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("取次CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("取次名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書店CD"),
      /*#__PURE__*/_createElementVNode("span", { class: "space-side" }, "番線"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("書店名")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, [
      /*#__PURE__*/_createTextVNode("書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN13桁")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_SyosiInfo" }, "書誌名"),
    /*#__PURE__*/_createElementVNode("th", null, "受注数"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_ZaikoStatus" }, [
      /*#__PURE__*/_createTextVNode("在庫"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ステータス")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "登録日"),
    /*#__PURE__*/_createElementVNode("th", null, "更新日"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("入力"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("担当者名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("営業"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("担当者名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "短冊メモ"),
    /*#__PURE__*/_createElementVNode("th", null, "社内備考"),
    /*#__PURE__*/_createElementVNode("th", null, "ｽﾃｰﾀｽ"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "OrderConfirm_Table_Sticky_TD" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "OrderConfirm_NormalBadge"
}
const _hoisted_16 = {
  key: 3,
  class: "OrderConfirm_MultiBadge"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "Text_Left" }
const _hoisted_19 = { class: "space-side" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "Text_Left" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "OrderConfirm_Table_SyosiInfo Table_Left Text_Left" }
const _hoisted_24 = { class: "OrderConfirm_Table_ZaikoStatus" }
const _hoisted_25 = {
  key: 0,
  class: "OrderConfirm_Table_BeforeRenkei"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "連携前", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "OrderConfirm_Table_AfterRenkei"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "連携済", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = {
  key: 2,
  class: "OrderConfirm_Table_Hold"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保留", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "OrderConfirm_Table_BtnArea" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "OrderConfirm_Table"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_Sticky_TH" }, "受注ID"),
    /*#__PURE__*/_createElementVNode("th", null, "明細件数"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("取次CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("取次名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書店CD"),
      /*#__PURE__*/_createElementVNode("span", { class: "space-side" }, "番線"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("書店名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN13桁")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_SyosiInfo" }, "書誌名"),
    /*#__PURE__*/_createElementVNode("th", null, "受注数"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderConfirm_Table_ZaikoStatus" }, [
      /*#__PURE__*/_createTextVNode("在庫"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ステータス")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "登録日"),
    /*#__PURE__*/_createElementVNode("th", null, "更新日"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("入力"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("担当者名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("営業"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("担当者名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "短冊メモ"),
    /*#__PURE__*/_createElementVNode("th", null, "社内備考"),
    /*#__PURE__*/_createElementVNode("th", null, "ｽﾃｰﾀｽ"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "OrderConfirm_Table_Sticky_TD" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = {
  key: 2,
  class: "OrderConfirm_NormalBadge"
}
const _hoisted_45 = {
  key: 3,
  class: "OrderConfirm_MultiBadge"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = { class: "Text_Left" }
const _hoisted_48 = { class: "space-side" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { class: "Text_Left" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = { class: "OrderConfirm_Table_SyosiInfo Text_Left" }
const _hoisted_53 = { class: "OrderConfirm_Table_ZaikoStatus" }
const _hoisted_54 = {
  key: 0,
  class: "OrderConfirm_Table_BeforeRenkei"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "連携前", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = {
  key: 1,
  class: "OrderConfirm_Table_AfterRenkei"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "連携済", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = {
  key: 2,
  class: "OrderConfirm_Table_Hold"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保留", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = { class: "OrderConfirm_Table_BtnArea" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "ResultMessageNull"
}

import axios from "axios";
import { ref, reactive, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ShowOrderRefData } from "../types/order";
import Paginate from "vuejs-paginate-next";
import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import selectBarSingle from "../components/molecules/selectBarSingle.vue";
import { Notyf } from "notyf";
//@ts-ignore
import CsvHelper from "../functions/CsvHelper.js";
import { MeisaiData } from "@/types/juchu";

interface ListLayout {
  name: string;
  selectFlg: boolean;
}

interface ListStatus {
  name: string;
  selectFlg: boolean;
  value: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderConfirm',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const store = useStore();
const router = useRouter();
const notyf = new Notyf();
const { getTimeStamp } = CsvHelper();

//propsの定義
const props = __props;
// Emitの定義


// ルーターの定義
const $router = useRouter();

// ストアの初期化
store.commit("search/clearAuthData");

//ぱんくずヘッダー
const currentPathList = [{ name: "受注入力" }, { name: "受注照会" }];

// OrderHeaderに渡すフラグ--------------------------
let searchAreaToggle: boolean = true;

//簡易検索-----------------------------------------
let isActive_KaniFlg = ref(false);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};

//詳細検索----------------------------------------
let isActive_SyosaiFlg = ref(true);
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

// 明細リストor見出しリストの判定用--------------------------
let isActiveMeisaiFlg = ref(false);

let selectBar_layout: {
  title: string;
  select_list: ListLayout[];
} = {
  title: "レイアウト",
  select_list: [
    { name: "見出し", selectFlg: true },
    { name: "明細", selectFlg: false },
  ],
};

const updateSelectLayout = (layout: ListLayout) => {
  // ページネーションを1ページに戻す
  currentPage.value = 1;
  store.commit("search/setPageNumber", currentPage.value);
  selectBar_layout.select_list.forEach((layout: ListLayout): void => {
    layout.selectFlg = false;
  });
  layout.selectFlg = true;
  if (layout.name == "明細") {
    isActiveMeisaiFlg.value = true;
  } else {
    isActiveMeisaiFlg.value = false;
  }
  getOrderRefData();
};

//ステータスの判定用
let selectBar_status = reactive<{
  title: string;
  select_list: ListStatus[];
}>({
  title: "ステータス",
  select_list: [
    { name: "すべて", selectFlg: true, value: 3 },
    { name: "連携前", selectFlg: false, value: 1 },
    { name: "連携済", selectFlg: false, value: 2 },
    { name: "保留", selectFlg: false, value: 0 },
  ],
});
// 選択中のステータス（デフォルトはすべて）
let selectedStatus: number | string = "";
const updateSelectStatus = (newStatus: ListStatus) => {
  // ページネーションを1ページに戻す
  currentPage.value = 1;
  store.commit("search/setPageNumber", currentPage.value);
  selectBar_status.select_list.forEach((status: ListStatus) => {
    status.selectFlg = false;
  });
  newStatus.selectFlg = true;
  selectedStatus = newStatus.value === 3 ? "" : newStatus.value;
  getOrderRefData();
};

//cartInfoは一旦any型で対応----------------------
// 修正ボタン
const openEdit = async (cartInfo: any) => {
  // 遷移処理
  let resolvedRoute = $router.resolve({
    name: "OrderConfirmEdit",
    params: { id: cartInfo.juchuId },
    query: {
      isActiveNormal: 1,
      isLogMode: 0,
      isActiveReference: cartInfo.juchuStatus == 2 ? 1 : 0,
    },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
  localStorage.setItem("onClickToroku", "false");
};
// 子ウィンドウが閉じた時点でのリロード処理
// localStorageの値を切り替えて対応
setInterval(() => {
  if (localStorage.getItem("onClickToroku") === "true") {
    getOrderRefData();
    localStorage.setItem("onClickToroku", "false");
  }
}, 1500);

// 照会ボタン（問題なければ削除）
// const openReference = (cartInfo: any, meisaiId: number = 0) => {
//   let resolvedRoute = $router.resolve({
//     name: "OrderConfirmReference",
//     params: { id: cartInfo.orderId },
//     query: { meisaiId },
//   });
//   window.open(
//     resolvedRoute.href,
//     "_blank",
//     "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
//       (window.screen.width - 1000) / 2 +
//       ",top=" +
//       (window.screen.height - 650) / 2
//   );
// };

// 出庫履歴のポップアップ表示
const openTab = async (juchuNumber: string): Promise<void> => {
  let resolvedRoute = router.resolve({
    name: "ShippingHistoryDetail",
    params: { id: juchuNumber },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1200,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};

//ダウンロード機能
let isLoading = ref(false);
const getCsvData = async () => {
  isLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getOrderRefDetailState"];
  const STATE = { ...detailState };
  const userInfo = store.getters["login/getUserData"];

  const changeNumber = (data: string) => {
    return data === "" ? data : Number(data);
  };

  try {
    isLoading.value = true;
    const searchParams = `hanmotoCd=${userInfo.hanmotoCd}&userId=${changeNumber(
      STATE.userId
    )}&freeword=${simpleState}&fromRegisterDate=${
      STATE.fromTourokuDate
    }&toRegisterDate=${STATE.toTourokuDate}&toritugiCd=${
      STATE.toritugiCd
    }&toritugiSyotenCd=${STATE.toritugiSyotenCd}&bansen=${
      STATE.bansen
    }&syotenCd=&torihikiCd=${changeNumber(
      STATE.torihikiCd
    )}&juchuKbn=${changeNumber(
      STATE.juchuKbn
    )}&janCd=&categoryCd=${changeNumber(
      STATE.categoryCd
    )}&salesName=${changeNumber(STATE.salesName)}&companyRemarks=${
      STATE.companyRemarks
    }&juchuStatus=${selectedStatus}&syosiCd=${STATE.syosiCd}&page=${
      currentPage.value
    }&numberOfDisplay=${dataPerPage}&headlineOrDetail=${!isActiveMeisaiFlg.value}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/chumonReference/download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    // console.log("res", res);

    isLoading.value = false;
    if (res.data === "") {
      notyf.error("ダウンロードするデータがありません");
    } else {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `受注照会_${getTimeStamp()}.xlsx`;
      link.click();
      isLoading.value = false;
    }
  } catch (error) {
    isLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const onSearch = () => {
  // ページネーションを1ページに戻す
  currentPage.value = 1;
  store.commit("search/setPageNumber", currentPage.value);
  getOrderRefData();
};

//受注データ取得
let search_result = ref<ShowOrderRefData[]>([]);
let search_result_midasi = ref<ShowOrderRefData[]>([]);
const getOrderRefData = async () => {
  search_result.value.splice(0);
  search_result_midasi.value.splice(0);
  await store.dispatch("search/searchOrderRef", {
    headlineOrDetail: !isActiveMeisaiFlg.value,
    juchuStatus: selectedStatus,
  });
  const res = store.getters["search/getOrderRefData"];
  console.log(res);

  let isBgGray = false;
  let preJuchuId = -1;
  res.juchuReferences.forEach((juchuRef: ShowOrderRefData) => {
    //テーブル背景色の判定のため、受注IDごとで明細を仕分けする
    if (preJuchuId !== juchuRef.juchuId) {
      isBgGray = !isBgGray;
    }
    juchuRef.isBgGray = isBgGray;
    preJuchuId = juchuRef.juchuId;
    search_result.value.push(juchuRef);
    search_result_midasi.value.push(juchuRef);
  });
  // console.log(search_result.value);

  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;
  getTotalPage();
  // getOrderMidasiData();
  // console.log("search_result", search_result.value);
};
getOrderRefData();

//見出しレイアウト用の受注データ生成
// const getOrderMidasiData = () => {
//   let midasi_array = [...search_result.value];
//   let preJuchuId = -1;
//   // console.log(search_result.value);
//   // console.log("midasi_array", midasi_array);

//   let targetIndex = -1;

//   //明細数の計算
//   midasi_array.forEach((item, itemIdex) => {
//     // console.log(item.juchuId, preJuchuId);
//     if (item.juchuId !== preJuchuId) {
//       targetIndex = itemIdex;
//       midasi_array[targetIndex].meisaiNum = 1;
//     } else if (item.juchuId === preJuchuId) {
//       midasi_array[targetIndex].meisaiNum++;
//     }
//     preJuchuId = item.juchuId;
//   });

//   //同じjuchuIdを持つ明細のうち一件目の明細のみ抽出
//   const filter_midasi_array = midasi_array.filter(
//     ({ juchuId }, i) =>
//       i === midasi_array.findIndex((e) => e.juchuId === juchuId)
//   );

//   search_result_midasi.value.splice(
//     0,
//     search_result_midasi.value.length,
//     ...filter_midasi_array
//   );
// };

// ページネーション関連処理
let numberOfTotalData = ref(0); // 取得データ合計
let dataPerPage = 100; // 1ページあたりの表示データ数(一旦固定)
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
const numberOfTotalPage = ref(0); // 総ページ数
const currentPage = ref(1); // 現在のページ数
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getOrderRefData();
};

//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "OrderConfirm_TableContainer_Short";
  } else {
    //その他
    return "OrderConfirm_TableContainer_Long";
  }
};

// 営業担当者の名前取得用（APIから取得するデータのsalesNameには文字列のsalesCdが入っている）]
//営業担当者リスト
const salesList = store.getters["constant/getSalesList"];
const getSalesName = (salesCd: string) => {
  let salesName = "";
  if (typeof salesCd === "string" && salesCd.length > 0) {
    let result: undefined | string = salesList.find(
      (sales: { salesCd: number }) => {
        return Number(salesCd) === sales.salesCd;
      }
    )?.salesName;
    if (result !== undefined) salesName = result;
  }
  return salesName;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderConfirm", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      searchType: "orderConfirm",
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(selectBarSingle, {
          selectBarList_props: _unref(selectBar_layout),
          onUpdateSelectValue: updateSelectLayout,
          class: "OrderConfirm_SelectContainer"
        }, null, 8, ["selectBarList_props"]),
        _createVNode(selectBarSingle, {
          selectBarList_props: _unref(selectBar_status),
          onUpdateSelectValue: updateSelectStatus,
          class: "OrderConfirm_SelectContainer_Right"
        }, null, 8, ["selectBarList_props"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["OrderConfirm_BtnGray", { OrderConfirm_BtnDisabled: _unref(isLoading) }]),
          download: "sample.txt",
          disabled: _unref(isLoading),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getCsvData()))
        }, [
          (!_unref(isLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 10, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Paginate), {
        "page-count": numberOfTotalPage.value,
        "hide-prev-next": true,
        "page-range": 3,
        "prev-text": '<',
        "next-text": '>',
        "container-class": 'pagination',
        "page-class": 'page-item',
        "page-link-class": 'page-item--link',
        "active-class": 'page-item--active',
        "click-handler": onClickPage,
        "force-page": currentPage.value
      }, null, 8, ["page-count", "force-page"]),
      _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
        [_vShow, _unref(search_result).length]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["OrderConfirm_MainArea", tableHeight()])
    }, [
      (_unref(isActiveMeisaiFlg))
        ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
            _hoisted_9,
            (_unref(search_result).length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (cartInfo, cartIndex) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: cartIndex,
                      class: _normalizeClass([cartInfo.isBgGray ? 'tr_bg-gray' : 'tr_bg-white', "tr-border"])
                    }, [
                      _createElementVNode("td", _hoisted_11, [
                        (
                    cartInfo.juchuNumber === '' || cartInfo.juchuNumber === null
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(cartInfo.juchuId), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "link",
                              onClick: ($event: any) => (openTab(cartInfo.juchuNumber))
                            }, _toDisplayString(cartInfo.juchuId), 9, _hoisted_13)),
                        _hoisted_14,
                        (cartInfo.chumonMode === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "通常入力"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, "マルチ入力"))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.meisaiId), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(cartInfo.toritugiCd), 1),
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(cartInfo.toritugiMei), 1)
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createTextVNode(_toDisplayString(cartInfo.toritugiSyotenCd), 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(cartInfo.bansen), 1),
                        _hoisted_20,
                        _createTextVNode(_toDisplayString(cartInfo.syotenMei), 1)
                      ]),
                      _createElementVNode("td", _hoisted_21, [
                        _createTextVNode(_toDisplayString(cartInfo.syosiCd), 1),
                        _hoisted_22,
                        _createTextVNode(_toDisplayString(cartInfo.janCd), 1)
                      ]),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(cartInfo.title), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.quantity), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(cartInfo.zsName), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.registerDate), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.kousinDate), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.username), 1),
                      _createElementVNode("td", null, _toDisplayString(getSalesName(cartInfo.salesName)), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.tanzaku), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.companyRemarks), 1),
                      (cartInfo.juchuStatus == 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                            _createVNode(_component_font_awesome_icon, { icon: "square" }),
                            _hoisted_26,
                            _createTextVNode(),
                            _hoisted_27
                          ]))
                        : (cartInfo.juchuStatus == 2)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                              _createVNode(_component_font_awesome_icon, { icon: "square" }),
                              _hoisted_29,
                              _createTextVNode(),
                              _hoisted_30
                            ]))
                          : (cartInfo.juchuStatus == 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                                _createVNode(_component_font_awesome_icon, { icon: "square" }),
                                _hoisted_32,
                                _createTextVNode(),
                                _hoisted_33
                              ]))
                            : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_34, [
                        (cartInfo.juchuStatus == 2)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (openEdit(cartInfo)),
                              class: "OrderConfirm_Table_Button"
                            }, " 参照 ", 8, _hoisted_35))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (openEdit(cartInfo)),
                              class: "OrderConfirm_Table_Button"
                            }, " 修正 ", 8, _hoisted_36))
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_unref(isActiveMeisaiFlg))
        ? (_openBlock(), _createElementBlock("table", _hoisted_37, [
            _hoisted_38,
            (_unref(search_result_midasi).length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result_midasi), (cartInfo, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass([index % 2 !== 0 ? 'tr_bg-gray' : 'tr_bg-white', "tr-border"])
                    }, [
                      _createElementVNode("td", _hoisted_40, [
                        (
                    cartInfo.juchuNumber === '' || cartInfo.juchuNumber === null
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(cartInfo.juchuId), 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "link",
                              onClick: ($event: any) => (openTab(cartInfo.juchuNumber))
                            }, _toDisplayString(cartInfo.juchuId), 9, _hoisted_42)),
                        _hoisted_43,
                        (cartInfo.chumonMode === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, "通常入力"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_45, "マルチ入力"))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.numberOfDetails), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(cartInfo.toritugiCd), 1),
                        _hoisted_46,
                        _createTextVNode(_toDisplayString(cartInfo.toritugiMei), 1)
                      ]),
                      _createElementVNode("td", _hoisted_47, [
                        _createTextVNode(_toDisplayString(cartInfo.toritugiSyotenCd), 1),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(cartInfo.bansen), 1),
                        _hoisted_49,
                        _createTextVNode(_toDisplayString(cartInfo.syotenMei), 1)
                      ]),
                      _createElementVNode("td", _hoisted_50, [
                        _createTextVNode(_toDisplayString(cartInfo.syosiCd), 1),
                        _hoisted_51,
                        _createTextVNode(_toDisplayString(cartInfo.janCd), 1)
                      ]),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(cartInfo.title), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.quantity), 1),
                      _createElementVNode("td", _hoisted_53, _toDisplayString(cartInfo.zsName), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.registerDate), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.kousinDate), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.username), 1),
                      _createElementVNode("td", null, _toDisplayString(getSalesName(cartInfo.salesName)), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.tanzaku), 1),
                      _createElementVNode("td", null, _toDisplayString(cartInfo.companyRemarks), 1),
                      (cartInfo.juchuStatus == 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                            _createVNode(_component_font_awesome_icon, { icon: "square" }),
                            _hoisted_55,
                            _createTextVNode(),
                            _hoisted_56
                          ]))
                        : (cartInfo.juchuStatus == 2)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_57, [
                              _createVNode(_component_font_awesome_icon, { icon: "square" }),
                              _hoisted_58,
                              _createTextVNode(),
                              _hoisted_59
                            ]))
                          : (cartInfo.juchuStatus == 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                                _createVNode(_component_font_awesome_icon, { icon: "square" }),
                                _hoisted_61,
                                _createTextVNode(),
                                _hoisted_62
                              ]))
                            : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_63, [
                        (cartInfo.juchuStatus == 2)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (openEdit(cartInfo)),
                              class: "OrderConfirm_Table_Button"
                            }, " 参照 ", 8, _hoisted_64))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (openEdit(cartInfo)),
                              class: "OrderConfirm_Table_Button"
                            }, " 修正 ", 8, _hoisted_65))
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (!_unref(search_result).length || !_unref(search_result_midasi).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, " ※検索結果はありません "))
      : _createCommentVNode("", true)
  ], 2))
}
}

})